import { useState, useEffect } from 'react';
import { EventEmitter } from '@/utils/eventEmitter';

export enum DEVICE_TYPE {
  PC,
  TABLET,
  MOBILE,
}

let DriverWidth = 0;

const excludeMobile = ['/invest'];

let type = getDriverType();
export let deviceTypeIsMobile = type === DEVICE_TYPE.MOBILE;

export function getDriverType() {
  const { innerWidth, outerWidth } = window;
  let width = innerWidth;
  if (outerWidth && outerWidth < innerWidth && outerWidth >= 320) {
    width = outerWidth;
  }
  DriverWidth = width;
  if (width > 1240) {
    return DEVICE_TYPE.PC;
  } else if (width < 600 && !excludeMobile.find(v => window.location.pathname.startsWith(v))) {
    return DEVICE_TYPE.MOBILE;
  } else {
    return DEVICE_TYPE.TABLET;
  }
}

export { DriverWidth };

const eventEntry = new EventEmitter();

export const checkDeviceInfo = () => {
  const _type = type;
  type = getDriverType();
  if (type === _type) return;
  deviceTypeIsMobile = type === DEVICE_TYPE.MOBILE;
  eventEntry.emit('changeDeviceType');
  eventEntry.emit('changeIsMobile');
};

window.addEventListener('resize', checkDeviceInfo);

export function useDeviceType(): DEVICE_TYPE {
  const [t, setT] = useState(type);
  useEffect(function () {
    function boundReset() {
      setT(type);
    }
    eventEntry.on('changeDeviceType', boundReset);
    return function () {
      eventEntry.off('changeDeviceType', boundReset);
    };
  }, []);
  return t;
}

export function useDeviceTypeIsMobile(): boolean {
  const [t, setT] = useState(deviceTypeIsMobile);
  useEffect(function () {
    function boundReset() {
      setT(deviceTypeIsMobile);
    }
    eventEntry.on('changeIsMobile', boundReset);

    return function () {
      eventEntry.off('changeIsMobile', boundReset);
    };
  }, []);
  return t;
}

export default useDeviceType;
